import React from 'react';

const AvisoLegal = () => {
  return (
    <div className="container" style={{ padding: '3rem 0' }}>
      <h1>Aviso Legal</h1>
      
      <h2>Datos del Titular</h2>
      <p><strong>Nombre/Razón Social:</strong> [TU NOMBRE]</p>
      <p><strong>NIF/CIF:</strong> [TU NIF]</p>
      <p><strong>Domicilio:</strong> C/MAYOR 17, 08389 PALAFOLLS, BARCELONA</p>
      <p><strong>Email:</strong> [TU EMAIL]</p>
      <p><strong>Teléfono:</strong> 640 975 055 / 931 781 420</p>
      
      <h2>Actividad</h2>
      <p>Phone Paradise se dedica a la reparación de dispositivos móviles y venta de accesorios. Los pedidos y presupuestos se gestionan a través de WhatsApp y en tienda física.</p>
      
      <h2>Propiedad Intelectual</h2>
      <p>Todos los contenidos de esta web están protegidos por derechos de propiedad intelectual.</p>
      
      <h2>Legislación Aplicable</h2>
      <p>Esta web se rige por la legislación española, en particular por la Ley 34/2002 de Servicios de la Sociedad de la Información (LSSI-CE).</p>
    </div>
  );
};

export default AvisoLegal;